import {Status} from '../types';

export const statusList = [
  Status.active,
  Status.inactive,
  Status.expired,
  Status.underReview
];

export const statusFilterConfig = {
  [Status.active]: {
    text: 'BenefitStatus.active',
    value: Status.active
  },
  [Status.inactive]: {
    text: 'BenefitStatus.inactive',
    value: Status.inactive
  },
  [Status.expired]: {
    text: 'BenefitStatus.expired',
    value: Status.expired
  },
  [Status.underReview]: {
    text: 'BenefitStatus.underReview',
    value: Status.underReview
  },
  [Status.pending]: {
    text: 'BenefitStatus.pending',
    value: Status.pending
  }
};
